import React, { useState } from "react";
import { FaMinus, FaPlus } from "react-icons/fa";

function FAQ(props) {
  const [expand, setExpand] = useState(false);
  const expandClass = expand ? "display" : "hidden";
  const ansClass = `${expandClass} p-0`;

  return (
    <>
      <div key={props.key} className='flex justify-center'>
        <div className='w-full rounded-sm bg-transparent border-t-[1px]'>
          <div
            className='p-0 text-sm sm:text-lg font-medium cursor-pointer'
            onClick={() => setExpand(!expand)}
          >
            <div
              className={`flex gap-2 sm:gap-0 justify-between items-center p-3 sm:p-4 mb-1.5 border-blue-200 ${
                expand
                  ? "border-b-0 border-t-[1px] border-l-[1px] border-r-[1px] mb-0"
                  : "border"
              }`}
            >
              <h1 className='font-medium text-lg flex-wrap text-black'>
                {props.question}
                <span className='bg-blue-100 px-1.5 py-1 rounded-full text-[16px] text-blue-500 ml-3 sm:ml-5'>
                  $99.00
                </span>
              </h1>
              <div>
                <button className='text-xl text-center'>
                  {expand ? (
                    <div className='flex items-center justify-center justify-items-center bg-blue-200 rounded-full p-1'>
                      <FaMinus className='fill-white' size={15} />
                    </div>
                  ) : (
                    <div className='flex items-center justify-center justify-items-center bg-blue-200 rounded-full p-1'>
                      <FaPlus className='fill-white' size={15} />
                    </div>
                  )}
                </button>
              </div>
            </div>
          </div>
          <div
            className={`
            ${ansClass}
            ${
              expand
                ? "border-t-0 border-b-[1px] border-l-[1px] border-r-[1px] mb-1.5 text-gray-500 leading-loose"
                : "border mb-0"
            } border-blue-200 text-[15.5px] p-3`}
          >
            {props.answer}
          </div>
        </div>
      </div>
    </>
  );
}

export default FAQ;
